import { Checkbox, CheckboxGroupProps, Grid, Group, } from "@mantine/core";
import { Ref, forwardRef, useContext, } from "react";
import { InstantSearch, useRefinementList, } from "react-instantsearch";
import TypesenseInstantsearchAdapter from "typesense-instantsearch-adapter";
import { MyUserDataContext } from "../contexts";
import { createRenderingInfoPrinter } from "../utils";


const debug = createRenderingInfoPrinter("SearchBoxComponent");

interface RmsSegmentSelectComponentProps {
    defaultValue?: string[];
    textProps?: Partial<CheckboxGroupProps>;
    onChange: (item: string[]) => void,
    segmentsList: string[],

}

export interface AutocompleteComponentHandle {

}

const SearchBoxComponent = forwardRef<AutocompleteComponentHandle, RmsSegmentSelectComponentProps>(
    ({ textProps, defaultValue, segmentsList, onChange, ...props }: RmsSegmentSelectComponentProps, ref: Ref<AutocompleteComponentHandle>) => {

        debug();

        const {
            items,
            refine,

        } = useRefinementList({ ...props, attribute: "segment", limit: 999 });



        return <Grid >
            <Checkbox.Group
                {...textProps}
                style={{ width: "100%" }}
                defaultValue={defaultValue}
                onChange={
                    (items) => {
                        if (onChange) {
                            onChange(items)
                        }
                    }
                }
                value={segmentsList}
            >
                <Group mt="xs">

                    {items.map((item, idx) => {

                        return <Checkbox
                            key={idx}
                            type="checkbox"
                            color="green"
                            checked={item.isRefined}
                            onChange={() => {
                                refine(item.value)
                            }}
                            value={item.value}
                            label={
                                <>
                                    <span>({item.count})</span>  {item.label}
                                </>
                            }
                        />
                    }
                    )}
                </Group>
            </Checkbox.Group>


        </Grid >

    }
);

export const RmsSegmentSelectComponent = forwardRef<AutocompleteComponentHandle, RmsSegmentSelectComponentProps>(
    ({ textProps, defaultValue, onChange, segmentsList }: RmsSegmentSelectComponentProps, ref: Ref<AutocompleteComponentHandle>) => {
        const userData = useContext(MyUserDataContext);


        const typesenseInstantsearchAdapter = new TypesenseInstantsearchAdapter({
            server: {
                apiKey: userData.rmsCollectionSearchKey!, // Be sure to use a Search API Key
                nodes: [
                    {
                        host: import.meta.env.VITE_TYPESENSE_SEARCH_HOST!,
                        port: 443,
                        protocol: 'https',

                    },

                ],


            },
            additionalSearchParameters: {
                query_by: "segment",
                facet_by: "segment",
                max_facet_values: 999,

            }
        });

        const typesenseSearchClient = typesenseInstantsearchAdapter.searchClient;

        return (
            <InstantSearch indexName={import.meta.env.VITE_TYPESENSE_RMS_COLLECTION as string}

                searchClient={typesenseSearchClient}>
                <SearchBoxComponent segmentsList={segmentsList} textProps={textProps} defaultValue={defaultValue} onChange={onChange} />
            </InstantSearch>
        );
    }
);
